export enum GtmEventEnum {
  DEFAULT = 'VardenGA',
  VIRTUAL_PAGE_VIEW = 'virtualPageview',
  CTA_CLICK = 'ctaClick',
  VIEW_ITEM_LIST = 'view_item_list',
}
